import React from "react";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import useSmallNav from "../../../../hooks/useSmallNav";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import navara from "./../../../../assets/info/navara-hero.jpg";
import { popularVehicle } from "../../../../vars/popularVehicles";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";

const NissanNavara = () => {
  useSmallNav("Nissan Navara");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Nissan Navara"} bolder />
        <InfoHero image={navara} />
        <InfoGrid>
          <div>
            <p>
              Nissan Pickup Navara D21 pojawił się na rynku w 1985 roku zarówno
              jako 2WD i 4WD. Dzięki swojej prostocie zyskał reputację
              niezawodnej i wytrzymałej konstrukcji, o nieco prostym i skromnym
              wyposażeniu, czy też stylistyce.
            </p>
            <p>
              Kolejna wersja, D22 pojawiła się w 1997 roku i była już bardziej
              wyrafinowana, ale wciąż miała wiele części mechanicznych wspólnych
              z poprzednim modelem.
            </p>
            <p>
              Największą zmianą była zupełnie nowa, trzecia już seria D40, która
              pojawiła się w 2005 roku. W tym modelu postawiono szczególny
              nacisk na komfort i wygodę, przy jednoczesnym zachowaniu walorów
              użytkowych i eksploatacyjnych, dwóch poprzednich modeli.
            </p>
            <p>
              W roku 2015 na rynku zadebiutował model D23. Zupełnie inny od
              poprzednich zarówno w stylistyce, jak i komforcie, dzięki tylnemu
              zawieszeniu na sprężynach śrubowych, a nie jak dotychczas na
              resorach piórowych. Wybrane modele, na niektórych rynkach wciąż
              jednak można było zakupić z resorami przy tylnej osi.
            </p>
            <p>
              Pedders nie tylko dostarcza standardowe części zamienne
              zawieszenia, ale oferuje również zestawy podnoszące zdolności
              terenowe i transportowe Twojego pickupa. To nie tylko amortyzatory
              i sprężyny, to także tuleje, wahacze i wiele innych, które
              poprawią prowadzenie Twojego samochodu.
            </p>
            <InfoHeader
              size="smaller"
              text={"Pierwsze pytanie brzmi: „Czego oczekuję od mojej Navary?”"}
            />
            <p>
              Jeśli chcesz bawić się swoim samochodem, podnieść zawieszenie,
              zwiększyć skok zawieszenia, założyć większe opony itp., sprawdź
              kategorię „Zestawy”.
            </p>
            <p>
              Jeśli stale holujesz przyczepy lub przewozisz ładunki swoją
              Navarą, nasza oferta jest skierowana do Ciebie. Odpowiednio
              dobrane amortyzatory i elementy sprężyste, zapewniają prawidłową
              pracę zawieszenia, niezależnie od tego czy przewozisz ciężkie
              towary, w samochodzie podniesionym czy w standardowej wysokości.
            </p>
            <p>
              Wybierz swój pojazd z listy, a jeśli masz jakieś wątpliwości, nie
              wahaj się zapytać, a nasz zespół pomoże w doborze.
            </p>
            <InfoHeader
              size="smaller"
              text={"Jak wysoka będzie moja Navara?"}
            />
            <p>
              Chociaż opisy zestawów podają przybliżone parametry, mogą one być
              trochę mylące. Jak wspomniano, sprężyny osiadają z czasem, więc
              1,5-calowe podwyższenie może okazać się nieco większe w
              rzeczywistości. Aby upewnić się, że dokładnie wiesz, co
              otrzymujesz, podajemy również dopasowaną wysokość. Mierzy się ją
              od dolnego rantu felgi do nadkola. Zaletą tej metody jest to, że
              wybór opon nie ma wpływu na podaną wysokość.
            </p>
            <p>
              Jeśli nadal nie jesteś pewien, czy mamy odpowiednie dla Ciebie
              części? Nie wiesz, który zestaw jest dla Ciebie odpowiedni?
              Skontaktuj się z nami, a nasz zespół zadba o to, że otrzymasz
              części odpowiednie do Twoich potrzeb.
            </p>
          </div>
          <div>
            {popularVehicle
              .find((e) => e.make === "Nissan")
              .models.find((e) => e.display === "Navara")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
            <iframe
              title={"Nissan Navara"}
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/GW549IzY_98"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              title={"Nissan Navara 2"}
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/KnT6sI4QaYk"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              title={"Nissan Navara 3"}
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
        </InfoGrid>
        {/* <InfoFooter make="Nissan" model="Navara" /> */}
      </Container>
    </section>
  );
};

export default NissanNavara;
